import { CheckCircleHollowIcon } from "../icons"

export const InsuranceList = {

  getContent: ({ title = '', epli = '', consumer = '', home = '', travel = '' }) => `
    <h4 class="heading--base text--bold text--black h-margin-bottom-xs">${title}</h4>
    <div class="insurance-list__box">
      <h5 class="heading--small text--bold text--black">Epli</h5>
      <div class="insurance-list__icon-text">
        ${epli === 'full' ? CheckCircleHollowIcon() : ''}
        ${InsuranceList.setInsuranceText(epli)}
      </div>
    </div>
    <h5 class="heading--small text--bold h-margin-bottom-xs">Neytendalög</h5>
    ${InsuranceList.setInsuranceText(consumer)}
    <div class="h-divider"></div>
    <h5 class="heading--small text--bold h-margin-bottom-xs">Heimilistrygging</h5>
    ${InsuranceList.setInsuranceText(home)}
    <div class="h-divider"></div>
    <h5 class="heading--small text--bold h-margin-bottom-xs">Ferðatrygging</h5>
    ${InsuranceList.setInsuranceText(travel)}
  `,

  setInsuranceText: (type = ''): string => {

    let text = ''
    let className = ''

    if (type === 'none') {
      text = 'Enginn bótaréttur'
      className = 'text--red'
    }
    if (type === 'full') {
      text = 'Fullur bótaréttur'
      className = 'text--green'
    }
    if (type === 'limited') {
      text = 'Takmarkaður bótaréttur'
      className = 'text--gray'
    }

    return `<p class="text--small ${className}">${text}</p>`

  },
}
